import { useState } from 'react'
import { Button, ListItemIcon, Menu, MenuItem } from '@mui/material'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import GridOnIcon from '@mui/icons-material/GridOn'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import DescriptionIcon from '@mui/icons-material/Description'
import { exportToCsv, exportToExcel, exportToPdf } from '../../utils/export'

/**
 * Botão de exportação (Excel / PDF / CSV) usado nas telas de consulta
 * e nos relatórios.
 *
 * `resolveRows` é opcional: quando a tela pagina no servidor, `rows` é só a
 * página visível. Passe `resolveRows` (async () => linhas) para exportar o
 * conjunto filtrado inteiro — o menu aguarda a busca antes de gerar o arquivo.
 * Sem ele, exporta `rows` como antes.
 */
const ExportMenu = ({ rows, columns, fileName, title, disabled, resolveRows }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [busy, setBusy] = useState(false)
  const close = () => setAnchorEl(null)

  const run = async gerar => {
    close()
    setBusy(true)
    try {
      const dados = resolveRows ? await resolveRows() : rows
      if (dados && dados.length > 0) gerar(dados)
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<FileDownloadIcon />}
        disabled={disabled || busy || !rows || rows.length === 0}
        onClick={event => setAnchorEl(event.currentTarget)}
      >
        {busy ? 'Exportando…' : 'Exportar'}
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={close}>
        <MenuItem onClick={() => run(dados => exportToExcel(dados, columns, fileName, title))}>
          <ListItemIcon>
            <GridOnIcon fontSize="small" />
          </ListItemIcon>
          Excel (.xlsx)
        </MenuItem>
        <MenuItem onClick={() => run(dados => exportToPdf(dados, columns, fileName, title))}>
          <ListItemIcon>
            <PictureAsPdfIcon fontSize="small" />
          </ListItemIcon>
          PDF
        </MenuItem>
        <MenuItem onClick={() => run(dados => exportToCsv(dados, columns, fileName))}>
          <ListItemIcon>
            <DescriptionIcon fontSize="small" />
          </ListItemIcon>
          CSV
        </MenuItem>
      </Menu>
    </>
  )
}

export default ExportMenu
